
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/auth",
      function () {
        return require("private-next-pages/auth.tsx");
      }
    ]);
  